import { IconButton } from '@/components/ui/icon-button'
import { Text } from '@/components/ui/text'
import { A } from '@solidjs/router'
import { css } from 'styled-system/css'
import { Flex } from 'styled-system/jsx'

const BackArrowIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
  >
    <path d="M19 12H5M11 18l-6-6 6-6" />
  </svg>
)

export default function Crumb() {
  return (
    <Flex
      alignItems="center"
      gap="11px"
      display={{ base: 'flex', mdDown: 'none' }}
    >
      <A href="/setups">
        <IconButton
          type="button"
          style={{
            background: 'var(--colors-editorial-chip)',
            color: 'var(--colors-editorial-ink)',
            border: '1px solid var(--colors-editorial-hair-strong)',
          }}
          class={css({
            w: '34px',
            h: '34px',
            minW: '34px',
            borderRadius: '9px',
            '& svg': { width: '17px', height: '17px' },
            _hover: { bg: 'editorialHover' },
          })}
        >
          <BackArrowIcon />
        </IconButton>
      </A>
      <Flex alignItems="center" gap="6px">
        <Text fontSize="12px" color="editorialInk3" fontWeight="500">Setups</Text>
        <Text fontSize="12px" color="editorialInk3" fontWeight="500">·</Text>
        <Text fontSize="12px" color="editorialInk3" fontWeight="500">Details</Text>
      </Flex>
    </Flex>
  )
}
